module.exports = __webpack_public_path__ + "static/media/teen-burger-3-hero-mobile.b6d71f81.jpg";